import { isTypeProcessStep, TypeProcessStepSkeleton } from '@platform/contentful';
import { Entry } from 'contentful';
import MarkdownText from './util/MarkdownText';
import { legacyIconsToNewIcons } from './util/legacy-icons';
import { Icon } from '@platform/components';

const ContentfulProcessStep = ({
  entry,
  stepNumber,
  isLastStep,
}: {
  entry: Entry<TypeProcessStepSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
  stepNumber: number;
  isLastStep: boolean;
}) => {
  if (!entry || !isTypeProcessStep(entry)) {
    return null;
  }

  const icon = entry.fields.icon && legacyIconsToNewIcons[entry.fields.icon];

  return (
    <div className='relative float-left grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 items-center'>
      <div className='border-2 border-gray-500 rounded-full w-12 h-12 shrink-0 flex items-center justify-center font-header text-4xl font-semibold text-gray-500'>
        <span className='fa fal fa-plane' />
        {icon ?
          <Icon type={icon} />
        : stepNumber}
      </div>
      <h4 className='font-header text-xl sm:text-2xl leading-6 sm:leading-7 text-gray-500'>
        {entry.fields.header}
      </h4>
      {!isLastStep && <div className='h-full mx-auto border-r-3' />}
      {isLastStep && <div />}
      <div className='mb-4'>
        <MarkdownText text={entry.fields.description} />
      </div>
    </div>
  );
};

export default ContentfulProcessStep;
